module.exports = __webpack_public_path__ + "static/freescan-17b46928670ef1f7f05b5d7c3913f82c.jpg";